export const MenuIconPaths = {
    Api: 'menu/api.svg',
    Attendance: 'menu/attendance.svg',
    AttendanceScanning: 'menu/attendance_scanning.svg',
    BlockDates: 'menu/holiday.svg',
    Booking: 'menu/booking.svg',
    CcaSignUps: 'menu/event_sport_music.svg',
    Customisation: 'menu/personalization.svg',
    Diary: 'menu/calendar.svg',
    Email: 'menu/email.svg',
    Groups: 'menu/groups.svg',
    Home: 'menu/home.svg',
    JoinRequests: 'menu/who_we_are.svg',
    Locations: 'menu/pathways.svg',
    OnlineParentMeetings: 'menu/parent_teacher_conference.svg',
    PortalLinks: 'menu/connection.svg',
    Profile: 'menu/user.svg',
    Registers: 'menu/authenticated.svg',
    Reports: 'menu/download.svg',
    Settings: 'menu/setting.svg',
    SSO: 'menu/sso.svg',
    SportsPortal: 'menu/sport_portal.svg',
    StaffRoles: 'menu/id_card.svg',
    StaffSchedule: 'menu/calendar.svg',
    Users: 'menu/user.svg',
    Welcome: 'menu/parent_communication.svg'
};
